import styled from "styled-components";
import { useState, useEffect } from "react";
import CheckBox from "../FormControls/CheckBox";

const StyledUserRulesGrid = styled.div`
    position: relative;
    overflow-y: scroll;
    border: solid 1px ${(props) => props.theme.color.bordergray};
    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    
    ::-webkit-scrollbar-track {
        background: ${(props) => props.theme.color.disabledgray};
        :disabled {
            background: #E0E0E0;
        }
    }
    
    ::-webkit-scrollbar-thumb {
        width: 10px;
        height: 10px;
        background-color: ${(props) => props.theme.color.gray};
    }
    
    ${({disabled}) => disabled && `
        background-color: lightgray;
        pointer-events: none;
    `}
`;

const GridHeaderRow = styled.div`
    display: flex;
    color: ${(props) => props.theme.color.primaryblue};
    background-color: ${(props) => props.theme.color.secondaryhover};
    border: none;
    height: 63px;
    box-sizing: border-box;

    > div {
        border-right: solid 1px white;
    }

    div:last-child {
        border-right: none;
    }
`;

const GridHeaderCell = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 10px;
    font-weight: 700;
    padding: 7px 7px;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    
    ${({order}) => order === 0 && `
    `}

    ${({order}) => order === 1 && `
        background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='deepskyblue'/></g></svg>") no-repeat;
        background-position: right 5px top 50%;
    `}
    
    ${({order}) => order === 2 && `
        background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' transform='rotate(180)' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='deepskyblue'/></g></svg>") no-repeat;
        background-position: right 5px top 50%;
    `}
`;

const GridRow = styled.div`
    display: flex;
    border: none;
    color: ${(props) => props.theme.color.gray};
    height: 25px;
    font-size: 12px;
    font-weight: 600;
    box-sizing: border-box;
    border-bottom: solid 1px ${(props) => props.theme.color.disabledgray};

    > div {
        border-right: solid 1px ${(props) => props.theme.color.disabledgray};
    }

    div:last-child {
        border-right: none;
    }
`;

const GridCell = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    padding: 0px 10px;
    box-sizing: border-box;
    cursor: pointer;
`;

function UserRulesGrid(props) {

    const {id, gridColumns, gridData, onChangeData, gridStyle, fontSize, disabled} = props;

    const ORDER_NONE = 0;
    const ORDER_ASC = 1;
    const ORDER_DES = 2;
    const [columnOrder, setColumnOrder] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);

    const changeColumnOrder = (columnIndex) => {
        if (columnIndex === 0) {
            let orders = structuredClone(columnOrder);
            for (let i = 0; i < orders.length; i ++) {
                orders[i] = ORDER_NONE;
            }
            orders[columnIndex] = (columnOrder[columnIndex] + 1) % 3;
            setColumnOrder(orders);
        }
    }

    const boolToString = (b) => {
        if (b === 1 || b === true) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    const sortItems = (a,b) => {
        for (let i = 0; i < columnOrder.length; i ++) {
            if (columnOrder[i] === ORDER_ASC) {
                if ( a[gridColumns[i].id] < b[gridColumns[i].id] ){
                    return -1;
                  }
                  if ( a[gridColumns[i].id] > b[gridColumns[i].id] ){
                    return 1;
                  }
                  return 0;
            }
            if (columnOrder[i] === ORDER_DES) {
                if ( a[gridColumns[i].id] < b[gridColumns[i].id] ){
                    return 1;
                  }
                  if ( a[gridColumns[i].id] > b[gridColumns[i].id] ){
                    return -1;
                  }
                  return 0;
            }
        }
    }

    const onChangeCheck = (item, columnId, val) => {
        if (onChangeData) {
            onChangeData(item, columnId, val);
        }
    }

    useEffect(() => {
        if (!pageLoaded) {
            setPageLoaded(true);

            let sorts = [];
            gridColumns.map((col) => {
                sorts.push(ORDER_NONE);
            });
            setColumnOrder(sorts);

            let strs = [];
            gridColumns.map((col) => {
                strs.push('');
            });
        }
    }, []);

    if (gridColumns.length > 0) {
        return (
            <StyledUserRulesGrid id={id} disabled={disabled} style={{...gridStyle, width: gridStyle.width+10}}>
                <GridHeaderRow>
                    {gridColumns.map((col, colIdx) => {
                        return <GridHeaderCell key={colIdx} order={columnOrder[colIdx]} onClick={() => changeColumnOrder(colIdx)} style={{width: col.width}}>{col.id}</GridHeaderCell>
                    })}
                </GridHeaderRow>
                        {[...gridData].sort(sortItems).map((item, itmIdx) => {
                            return <GridRow id={id+'_row_'+item.Id} disabled={disabled} key={itmIdx}>
                                {gridColumns.map((col, colIdx) => {
                                    return <GridCell key={colIdx} disabled={disabled} style={{width: col.width, textAlign: col.textAlign, fontSize: fontSize}}>
                                        {col.type.toUpperCase() === 'STRING' ? item[col.id] : ''}
                                        {col.type.toUpperCase() === 'CHECKBOX' && <CheckBox label='' checked={item[col.id]} onCheck={(val) => onChangeCheck(item, col.id, val)}></CheckBox>}
                                    </GridCell>
                                })}
                            </GridRow>;
                        })}
            </StyledUserRulesGrid>
        )
    } else {
        return <div></div>
    }
}

export default UserRulesGrid;